import { Component, OnInit } from '@angular/core';
import { FormGroup, FormBuilder, FormControl } from '@angular/forms';
import { CotacaoService } from '../../shared/Services/CotacaoService/cotacao-service.service';
import * as moment from 'moment';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ModalAdicionaisComponent } from '../modal-adicionais/modal-adicionais.component';
import { Router } from '@angular/router';
import { Location } from '@angular/common';
import { GetCupomService } from '../../shared/Services/GetCupom/get-cupom.service';
import { ModalMensajeComponent } from '../modal-mensaje/modal-mensaje.component';
import { Pais } from 'src/app/shared/Interfaces/Pais';
@Component({
  selector: 'app-mostrar-produtos',
  templateUrl: './mostrar-produtos.component.html',
  styleUrls: ['./mostrar-produtos.component.css']
})
export class MostrarProdutosComponent implements OnInit {
  couponForm: FormGroup;
  applyCoupon: FormGroup = new FormGroup({
    codigoCupom: new FormControl('')
  });
  imagePath: string;
  cupom: string;
  telefono: string;
  ShowImage: boolean;
  ShowTelefono: boolean;
  ShowEmail: boolean;
  ShowCupon: boolean;
  myDate = new Date();
  formatDate: string;
  ShowDolar: boolean;
  Dolar: any;
  DolarDate: any;
  listPaises: Pais[];
  listEstados: [];
  listPassageiros: [];
  datosStorage: any;
  cotizacion: string;
  produtosSugeridos: Array<any>;
  produtosSugeridosSinCupon: Array<any>;
  coberturas: any;
  dadosCotisacion: any;
  motivoViagem: any;
  opcionaisTest: any;
  coberturasOpcionais: any;
  dataVolta: string;
  codigoTipoProducto: string;
  codigoMotivoViagem: string;
  urlmostrarProductos: string;
  URLCotizacion: any;
  totalPeriodo: number;
  CupomInicio: string;
  CupomFim: string;
  constructor(
    private getCupomService: GetCupomService,
    private routers: Router,
    private cotacaoService: CotacaoService,
    private fb: FormBuilder,
    private modalService: NgbModal,
    private navigate: Router,
    private location: Location) { }
  showModalBox: boolean = false;

  ngOnInit() {
    this.URLCotizacion = JSON.parse(localStorage.URLParams);
    this.codigoMotivoViagem = JSON.parse(localStorage.getItem('codigoTipoProducto'));
    this.motivoViagem = localStorage.getItem('MotivoViagem');

    /*
    this.produtosSugeridos = JSON.parse(localStorage.CotizacionSinCupon)[0];
    this.produtosSugeridosSinCupon = JSON.parse(localStorage.Cotizacion)[0];
    */

    this.produtosSugeridos = JSON.parse(localStorage.Cotizacion)[0];
    this.produtosSugeridosSinCupon = JSON.parse(localStorage.CotizacionSinCupon)[0];


    this.coberturas = JSON.parse(localStorage.Cotizacion)[1];
    this.formatDate = this.myDate.toISOString().slice(0, 10);
    this.cupom = sessionStorage.getItem('Cupom');
    this.ShowCupon = (this.cupom === '' || this.cupom === undefined);
    this.cotizacion = JSON.stringify(localStorage.dadosCotizacionL);
    this.telefono = sessionStorage.getItem('Telefone');
    this.ConseguirCotizacionDolar();
    this.Dolar = sessionStorage.CotizacionDolar;
    this.DolarDate = sessionStorage.DateCotizacionDolar;
    if (sessionStorage.CotizacionDolar === '' || sessionStorage.CotizacionDolar === undefined){
      this.Dolar = '0.00';
    }
    this.ShowTelefono = (this.telefono === '' || this.telefono === undefined);
    this.obterPaises();
    this.obterEstados();
    this.obterPassageiros();
    this.datosStorage = JSON.parse(localStorage.getItem('dadosCotizacionL'));

    if (this.motivoViagem === 'M') {
      let dataVoltaMultiViagem = moment(this.datosStorage.dataIda).add(364, "days");
      this.datosStorage.dataVolta = {
        year: dataVoltaMultiViagem.year(),
        month: dataVoltaMultiViagem.month(),
        day: dataVoltaMultiViagem.date()
      }
      this.totalPeriodo = this.datosStorage.quantDias;
    } else {
      const volta = this.datosStorage.dataVolta.year + '-' + this.datosStorage.dataVolta.month + '-' + this.datosStorage.dataVolta.day;
      const ida = this.datosStorage.dataIda.year + '-' + this.datosStorage.dataIda.month + '-' + this.datosStorage.dataIda.day;
      this.totalPeriodo = moment(volta).diff(moment(ida), 'days') + 1;
    }
    this.couponForm = this.fb.group({
      origem: [this.datosStorage.origem],
      destino: [this.datosStorage.destino],
      dataIda: [this.datosStorage.dataIda],
      quantDias: [this.datosStorage.quantDias],
      dataVolta: [this.datosStorage.dataVolta],
      quantPassageirosMenor: [this.datosStorage.quantPassageirosMenor],
      quantPassageirosMaior: [this.datosStorage.quantPassageirosMaior],
      CodigoCoberturaOpcional: [],
      incluiEuropa: [this.datosStorage.incluiEuropa]
    });
    this.deshabilitarCampos();
  }

  deshabilitarCampos() {
    if (this.codigoMotivoViagem !== 'VI') {
      this.couponForm.get('destino').disable();
      this.couponForm.get('incluiEuropa').disable();
    }
  }

  ConseguirCotizacionDolar() {
    this.cotacaoService.GetCotizacionDolar()
      .subscribe(
        data => {
          if ((data.ResponseJSONData) !== '' || (data.ResponseJSONData) !== undefined) {
            sessionStorage.k('CotizacionDolar', data.ResponseJSONData[0].ValorCotacao.toFixed(2));
            sessionStorage.setItem('DateCotizacionDolar', data.ResponseJSONData[0].UltimoHorarioCotacao);
            this.Dolar = sessionStorage.CotizacionDolar;
            this.DolarDate = sessionStorage.DateCotizacionDolar;
          }
        });
  }

  ValidarFechaCupom() {
    this.getCupomService.GetCupom(sessionStorage.SessionID)
      .subscribe(
        data1 => {
          if ((data1.ResponseJSONData) !== '' || (data1.ResponseJSONData) !== undefined) {
            const resultado = data1.ResponseJSONData.find(cu => cu.CodigoCupon === this.applyCoupon.value.codigoCupom);
            const hoje = moment().format('DD-MM-YYYY');
            const inicioCupom = moment(resultado.FechaInicioVigencia).format('DD-MM-YYYY');
            const finCupom = moment(resultado.FechaFinVigencia).format('DD-MM-YYYY');
            if (moment(inicioCupom).isAfter(hoje) || moment(finCupom).isBefore(hoje)){
                this.cupom = '';
                this.applyCoupon.value.codigoCupom = '';
              } else {
               this.cupom = this.applyCoupon.value.codigoCupom;
               }
           } else {
          this.dadosCotisacion.cupom = this.cupom;
          localStorage.setItem("CuponUsado", this.cupom);
          this.RefazerCotacao();
           }
        });
  }

  datePickerContentToString(date) {
    return `${date.year}-${String(date.month).padStart(2, '0')}-${String(date.day).padStart(2, '0')}`
  }

  AplicarCupom() {
    this.dadosCotisacion = JSON.parse(localStorage.dadosCotizacionL);
    this.motivoViagem = localStorage.MotivoViagem;
    if (this.applyCoupon.value.codigoCupom !== '') {
      this.ValidarFechaCupom();
    } else {
      this.cupom = this.applyCoupon.value.codigoCupom;
      this.dadosCotisacion.cupom = this.cupom;
      localStorage.setItem("CuponUsado", this.cupom);
      this.RefazerCotacao();
    }
    /*
        let codigoTipoProducto: String;
        codigoTipoProducto = (this.dadosCotisacion.destino == 'BRA') ? "VN" : "VI";
        if (this.motivoViagem.motivoViagem == 'M')
          codigoTipoProducto = 'MV';
        this.cotacaoService.FazerCotacao(
          this.dadosCotisacion.destino,
          this.motivoViagem ? this.motivoViagem : "L",
          this.dadosCotisacion.incluiEuropa.value,
          this.datePickerContentToString(this.dadosCotisacion.dataIda),
          this.datePickerContentToString(this.dadosCotisacion.dataVolta),
          this.dadosCotisacion.quantPassageirosMaior,
          this.dadosCotisacion.quantPassageirosMenor,
          this.applyCoupon.value.codigoCupom,
          this.dadosCotisacion.quantDias,
          codigoTipoProducto,
          sessionStorage.SessionID)
          .subscribe(
            data => {
              if (JSON.stringify(data.ResponseJSONData) !== '' || JSON.stringify(data.ResponseJSONData) !== undefined) {
                localStorage.setItem('dadosCotizacionL', JSON.stringify(this.dadosCotisacion));
                sessionStorage.setItem('Cotizacion', JSON.stringify(data.ResponseJSONData));
                //this.ShowCupon = !(this.applyCoupon.value.codigoCupom);
                this.cupom = this.applyCoupon.value.codigoCupom;
                if (this.applyCoupon.value.codigoCupom)
                  this.produtosSugeridos = data.ResponseJSONData[0];
                else{
                  this.produtosSugeridosSinCupon = data.ResponseJSONData[0]
                  this.produtosSugeridos = data.ResponseJSONData[0]
                }

                //this.produtosSugeridos = data.ResponseJSONData[0]
                this.coberturas = data.ResponseJSONData[1]
              }
            }
          );
    */
  }

  obterPassageiros() {
    this.cotacaoService.ConsultaQuantidadePassageiros()
      .subscribe(
        data => {
          this.listPassageiros = data.ResponseJSONData;
        });
  }

  obterPaises() {
    this.cotacaoService.ConsultaPaises()
      .subscribe(
        data => {
          this.listPaises = data.ResponseJSONData;
          switch (this.codigoMotivoViagem) {
            case 'MV':
              this.listPaises = this.listPaises.filter(data => data.ISO3L === 'MUL');
              break;
            case 'VN':
              this.listPaises = this.listPaises.filter(data => data.ISO3L === 'BRA');
              break;
            default:
              {
                this.listPaises = this.listPaises.filter(data => data.ISO3L !== 'BRA' && data.ISO3L !== 'xxx' && data.ISO3L !== 'MUL');
                break;
              }
          }
        }
      )
  }

  obterEstados() {
    this.cotacaoService.ConsultaEstados()
      .subscribe(
        data => {
          this.listEstados = data.ResponseJSONData;
        });
  }

  RefazerCotacao() {
    let dadosCotacao = this.couponForm.getRawValue();

    let motivoViagem = localStorage.getItem('MotivoViagem');
    if (dadosCotacao.quantDias == null) {
      dadosCotacao.quantDias = 0;
    }
    if (dadosCotacao.destino == 'BRA')
      this.codigoTipoProducto = 'VN';
    if (dadosCotacao.destino != 'BRA')
      this.codigoTipoProducto = 'VI';
    if (motivoViagem == 'M') {
      this.codigoTipoProducto = 'MV';
      dadosCotacao.quantPassageirosMaior = 0;
    }
    let hoje = moment().format();
    //--------FILTROS DE FECHAS--------
    if (dadosCotacao.dataIda <= hoje) {
      const modalRef = this.modalService.open(ModalMensajeComponent, { windowClass: 'modal modalExtras in' });
      modalRef.componentInstance.Titulo = 'Error data';
      modalRef.componentInstance.Mensaje = 'As datas não podem ser menores que as atuais';
      this.couponForm.reset();
    }
    if (dadosCotacao.dataVolta < dadosCotacao.dataIda) {
      const modalRef = this.modalService.open(ModalMensajeComponent, { windowClass: 'modal modalExtras in' });
      modalRef.componentInstance.Titulo = 'Error data';
      modalRef.componentInstance.Mensaje = 'A data de volta não deve ser menor que a data de ida';
      this.couponForm.reset();
    }
    if (motivoViagem == 'L') {
      var volta =dadosCotacao.dataVolta.year + '-' + dadosCotacao.dataVolta.month + '-' + dadosCotacao.dataVolta.day;
      var ida =  dadosCotacao.dataIda.year + '-' + dadosCotacao.dataIda.month + '-' + dadosCotacao.dataIda.day;
      let totalDias = moment(volta).diff(moment(ida), 'days');

      if (totalDias > 120) {
        motivoViagem = 'E'
      }
    }
    if (motivoViagem == 'E') {
      var volta =dadosCotacao.dataVolta.year + '-' + dadosCotacao.dataVolta.month + '-' + dadosCotacao.dataVolta.day;
      var ida = dadosCotacao.dataIda.year + '-' + dadosCotacao.dataIda.month + '-' + dadosCotacao.dataIda.day;
      let totalDias = moment(volta).diff(moment(ida), 'days');
      if (totalDias > 120) {
        alert('O prazo em troca é de 120 dias')
        this.couponForm.reset();
      }
    };
    if (localStorage.MotivoViagem === "M")
      this.totalPeriodo = dadosCotacao.quantDias;
    else
    {
      var volta = dadosCotacao.dataVolta.year + '-' + dadosCotacao.dataVolta.month + '-' + dadosCotacao.dataVolta.day;
      var ida = dadosCotacao.dataIda.year + '-' + dadosCotacao.dataIda.month + '-' + dadosCotacao.dataIda.day;
      this.totalPeriodo = moment(volta).diff(moment(ida), 'days') + 1;
    }
    let cupom = sessionStorage.getItem('Cupom');
    if (!cupom) {
      if (this.applyCoupon.value.codigoCupom) {
        this.cupom = this.applyCoupon.value.codigoCupom;
        cupom = this.cupom;
      }
      else {
        this.cupom = "";
        cupom = this.cupom;
      }
    }
    console.log("Europa", dadosCotacao.incluiEuropa);

    // this.codigoMotivoViagem = motivoViagem;
    this.cotacaoService.FazerCotacao(
      dadosCotacao.destino,
      motivoViagem,
      dadosCotacao.incluiEuropa ? 1 : 0,
      this.datePickerContentToString(dadosCotacao.dataIda),
      this.datePickerContentToString(dadosCotacao.dataVolta),
      dadosCotacao.quantPassageirosMaior,
      dadosCotacao.quantPassageirosMenor,
      cupom,
      dadosCotacao.quantDias,
      this.codigoTipoProducto,
      sessionStorage.SessionID
    ).subscribe(
      data => {
        if (data.ResponseJSONData && data.ResponseJSONData !== '') {
          localStorage.setItem('dadosCotizacionL', JSON.stringify(this.couponForm.value));
          sessionStorage.setItem('Cotizacion', JSON.stringify(data.ResponseJSONData));
          if (!cupom)
            this.produtosSugeridosSinCupon = data.ResponseJSONData[0];
          else {
            //Cotizo sin cupon para mostrar la diferencia
            this.cotacaoService.FazerCotacao(
              this.couponForm.value.destino,
              motivoViagem,
              this.couponForm.value.incluiEuropa ? 1 : 0,
              this.datePickerContentToString(this.couponForm.value.dataIda),
              this.datePickerContentToString(this.couponForm.value.dataVolta),
              this.couponForm.value.quantPassageirosMaior,
              this.couponForm.value.quantPassageirosMenor,
              '',
              this.couponForm.value.quantDias,
              this.codigoTipoProducto,
              sessionStorage.SessionID
            ).subscribe(
              data2 => {
                this.produtosSugeridosSinCupon = data2.ResponseJSONData[0];
              });

          }
          this.produtosSugeridos = data.ResponseJSONData[0];

          this.coberturas = data.ResponseJSONData[1];
          //this.ngOnInit();
        }
        else {
          const modalRef = this.modalService.open(ModalMensajeComponent, { windowClass: 'modal modalExtras in' });
          modalRef.componentInstance.Titulo = 'Erro na cotação';
          modalRef.componentInstance.Mensaje = 'Não encontramos nenhum produto para os dados de cotação inseridos';
        }
      });
  }

  selecionarProduto(CodigoProduto) {
    this.coberturasOpcionais = JSON.parse(localStorage.Cotizacion)[3];
    this.coberturasOpcionais = this.coberturasOpcionais.filter(val => { return val.CodigoProduto === CodigoProduto });
    if (this.coberturasOpcionais.length == 0) {
      localStorage.setItem("ProductoSeleccionado", JSON.stringify(this.produtosSugeridos.filter(val => { return val.CodigoProduto === CodigoProduto })[0]));
      localStorage.setItem("AdicionalesSelected", '[]');
      this.routers.navigate(['/Pagamento']);

    } else {
      const modalRef = this.modalService.open(ModalAdicionaisComponent, { windowClass: 'modal modalExtras in' });
      localStorage.setItem("ProductoSeleccionado", JSON.stringify(this.produtosSugeridos.filter(val => { return val.CodigoProduto === CodigoProduto })[0]));
      modalRef.componentInstance.ValorProducto = this.produtosSugeridos.filter(val => { return val.CodigoProduto === CodigoProduto })[0].ValorProduto;
      modalRef.componentInstance.Adicionales = this.coberturasOpcionais;
      this.showModalBox = true;
    }
  }

  GotoMostrarProductos() {
    this.navigate.navigate(['/MostrarProdutos']);
  }

  GotoFazerCotacao() {
    this.urlmostrarProductos = '/Cotacao?' + this.URLCotizacion;
    this.urlmostrarProductos.replace(' ', '');
    this.navigate.navigate(['/Cotacao'], { queryParams: this.URLCotizacion });
  }
}
